import React from 'react';
import { ppData } from '../configs/ppData.config';
import { SocialSharing } from './SocialSharing/SocialSharing';
import { LABEL_LICENSED } from '../constants/labelValues';
import { dlDispatchAmplEvent } from '../../../events/dl.dispatchAmplEvent';
import { layoutValues } from '../configs/options';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_LAYOUT } from '../constants/searchParamKeys';
const layouts = layoutValues[0];
const ArtistLink = ({ prefix, name, url, quotes = false }) => (React.createElement("p", { className: "d:inline-block mt:6 mt:4:lg-up" },
    React.createElement("span", { className: "fw:700 fz:14" }, prefix),
    React.createElement("a", { className: "ff:abril-display fz:18 text:capitalize text:italic trs text:underline text:decoration-none:xl-up hover:text:underline", href: url, onClick: () => {
            dlDispatchAmplEvent('Art by', { target: name });
        } },
        quotes && '"',
        name,
        quotes && '"')));
export const Heading = () => {
    const [searchParams] = useSearchParams();
    const layoutValue = searchParams.get(SEARCH_PARAM_KEY_LAYOUT);
    const layout = layouts.find(({ value }) => value === layoutValue);
    return (React.createElement("div", null,
        React.createElement("div", { className: "d:flex jc:between" },
            React.createElement("h1", { className: "pos:r m:0 lts:001 fw:700 fz:18 fz:20:md-up fz:24:lg-up d:flex fd:column ai:start" },
                React.createElement("span", null,
                    ppData.originalTitle,
                    " "),
                !ppData.isOldCustom && layout !== undefined && (React.createElement("span", { className: "px:6 fz:10 lts:10p fw:400 lh:1.2 text:uppercase bd bd:xw:1" }, layout.value.includes('piece') ? 'Canvas Print' : layout.label))),
            React.createElement(SocialSharing, null)),
        ppData.artistCollection !== undefined
            ? React.createElement(ArtistLink, { prefix: "ART BY: ", url: ppData.artistCollection.url, name: ppData.artistCollection.title })
            : ppData.labels?.includes(LABEL_LICENSED) === true && ppData.mainCollection !== undefined
                ? React.createElement(ArtistLink, { prefix: "As featured in ", name: ppData.mainCollection.title, url: ppData.mainCollection.url, quotes: true })
                : ppData.designProjectCollection !== undefined &&
                    React.createElement(ArtistLink, { prefix: "As featured in the ", name: ppData.designProjectCollection.title, url: ppData.designProjectCollection.url, quotes: true })));
};
